"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { FileCheck, Shield, TrendingUp } from "lucide-react";
export default function OurServices() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    icon: FileCheck,
    title: "Unclaimed Funds Recovery",
    description: "We specialize in identifying and recovering funds from tax deed sales that rightfully belong to you.",
    delay: "0ms"
  }, {
    icon: Shield,
    title: "Foreclosure Funds Retrieval",
    description: "Our ethical approach ensures you regain money lost through foreclosure proceedings with transparency and care.",
    delay: "120ms"
  }, {
    icon: TrendingUp,
    title: "Asset Restoration",
    description: "Guided by integrity and compassion, we help restore your financial stability by reuniting you with what was lost.",
    delay: "240ms"
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="our-services" className="py-16 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4 !text-[hsl(224,76%,48%)]">Our Services</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            RR Recovery Solution provides compassionate, faith-based financial recovery services to help you reclaim what is rightfully yours.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          const isVisible = visibilities[i];
          const ref = refs[i];
          return <div key={i} data-index={i} ref={ref} className="opacity-0 translate-y-5 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transitionDelay: isVisible ? service.delay : '0ms'
          }}>
                <Card className="h-full group hover:shadow-strong hover:-translate-y-2 transition-all duration-[120ms] ease-[var(--ease-smooth)] cursor-pointer">
                  <CardContent className="pt-6">
                    <div className="flex flex-col items-center text-center gap-4">
                      <div className="w-16 h-16 rounded-full bg-primary-light flex items-center justify-center group-hover:bg-primary-light/80 transition-colors duration-[120ms]">
                        <Icon className="w-8 h-8 text-primary group-hover:text-primary-hover transition-colors duration-[120ms]" />
                      </div>
                      <CardTitle className="text-xl">{service.title}</CardTitle>
                      <CardDescription className="text-base leading-relaxed">
                        {service.description}
                      </CardDescription>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}